<script lang="ts">
    import type { PageSegment } from './Segments.types';

    interface Props {
        segment: PageSegment | undefined;
        currentOffset: number;
        paginate: (offset: number) => void;
    }

    let { segment, currentOffset, paginate }: Props = $props();

    const isCurrentOffset = $derived(segment?.offset === currentOffset);
</script>

{#if segment}
    <li
        class="reptile-segment-page__item"
        data-qa={isCurrentOffset ? 'reptile-paging-current' : `reptile-paging-page-${segment.pageNumber}`}
    >
        <button
            disabled={isCurrentOffset}
            class={['reptile-segment-page__button', isCurrentOffset && 'reptile-segment-page__button--current']}
            onclick={() => paginate(segment.offset)}>{segment.pageNumber}</button
        >
    </li>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/colors';

    .reptile-segment-page {
        &__item {
            float: left;
            min-width: 30px;
            font-weight: normal;
            text-align: center;
        }

        &__button {
            font-family: var(--oc-base-font-otto-sans), sans-serif;
            display: block;
            padding: tokens.$oc-base-dimension-8 10px;
            text-decoration: none;
            box-sizing: border-box;
            font-size: 0.75rem;
            line-height: 1.5em;
            background-clip: padding-box;
            border: medium none;
            border-radius: 3px;
            cursor: pointer;
            margin-bottom: 0;
            margin-top: 0;
            outline: 0 none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            font-weight: 400;
            text-align: center;
            width: 100%;
            min-height: 30px;
            background: none;
            color: colors.$reptile-color-black;

            &:hover:not(.reptile-bottom-paging__button--current) {
                background: colors.$reptile-color-gray-light;
                color: colors.$reptile-color-red-2;
            }

            &--current {
                color: colors.$reptile-color-red;
                font-weight: bold;
            }
        }
    }
</style>
